import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-welcome-api-popup',
    templateUrl: './welcome-api-popup.component.html',
    styleUrls: ['./welcome-api-popup.component.scss'],
    standalone: false
})
export class WelcomeApiPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close() {
    this.modalRef.close();
  }
}
